import {useEffect} from 'react';

export default function LogOut() {
  useEffect(() => {
      window.location.href='/app/logout';
  }, []);

  return null;
}
